// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"3701b503","453":"2c5bc9dc","597":"cb0a190b","598":"b7d4c750","692":"c051f469","716":"9584b6a3","771":"57466631"}[chunkId] + ".chunk.js";
};